import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '@/App';
import { toast } from 'sonner';

const TICKET_KEY = 'google_link_ticket';

/**
 * Where Google sends someone back after they choose to add Google sign-in to the account
 * they are already in. The ticket in sessionStorage proves they confirmed their password
 * before they left; their password itself never travels through the redirect.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
const LinkGoogleCallback = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('Adding Google sign-in…');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    (async () => {
      const sessionId = new URLSearchParams(window.location.hash.replace('#', '')).get('session_id');
      const ticket = sessionStorage.getItem(TICKET_KEY);
      sessionStorage.removeItem(TICKET_KEY);

      if (!sessionId || !ticket) {
        toast.error('That request could not be completed. Try again from Settings.');
        navigate('/dashboard/settings');
        return;
      }

      try {
        const { data } = await axios.post(`${API}/auth/google/link`, {
          session_id: sessionId, ticket,
        });
        toast.success(data.message);
      } catch (e) {
        toast.error(e.response?.data?.detail || 'Google sign-in could not be added');
      } finally {
        setStatus('Taking you back to Settings…');
        navigate('/dashboard/settings');
      }
    })();
    // Runs once: the Google session_id is single use.
  }, []);   // eslint-disable-next-line

  return (
    <div className="flex min-h-screen items-center justify-center"
         style={{ background: 'linear-gradient(135deg, #0a0a1a 0%, #1a0a2e 50%, #0a1628 100%)' }}>
      <div className="space-y-4 text-center">
        <div className="mx-auto h-10 w-10 animate-spin rounded-full border-2 border-cyan-400
                        border-t-transparent" />
        <p className="text-lg text-cyan-200" data-testid="link-google-status">{status}</p>
      </div>
    </div>
  );
};

export default LinkGoogleCallback;
